// import React, { useEffect, useState } from "react";
// import { Form, Input, Button, Upload, Select, message } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import { UserService } from "../../Services/Manage/UserService";
// import axios from "axios";
// import useMessage from "antd/es/message/useMessage";
// import { AnnounceServices } from "../../Services/Room/AnnounceServices";

// const { TextArea } = Input;
// const { Option, OptGroup } = Select;

// const CreateAnnounce = ({ onClose }) => {
//     const [form] = Form.useForm();
//     const [users, setUsers] = useState([]);
//     const [groupedUsers, setGroupedUsers] = useState({});
//     const [fileList, setFileList] = useState([]);
//     const [message, msgContx] = useMessage();

//     const handleSubmit = async (values) => {
//         try {
//             const formData = new FormData();

//             const user = await UserService.getAllUsers();

//             formData.append("title", values.title);
//             formData.append("description", values.content);
//             formData.append("added_by", user.uid);
//             formData.append("mention", JSON.stringify(values.mention || []));

//             fileList.forEach((file) => {
//                 formData.append("image", file.originFileObj);
//             });

//             // const res = await axios.post(
//             //     "http://localhost:8084/api/v1/room/announce",
//             //     formData,
//             //     { headers: { "Content-Type": "multipart/form-data" } }
//             // );

//             const res = await AnnounceServices.createAnnounce(formData);

//             if (res.data.success) {
//                 message.success("Announcement posted successfully!");
//                 form.resetFields();
//                 setFileList([]);
//                 onClose();
//             } else {
//                 message.error(res.data.message || "Failed to post announcement");
//             }
//         } catch (err) {
//             console.error("Error posting announcement:", err);
//             message.error("Error posting announcement");
//         }
//     };

//     const getAllUser = async () => {
//         try {
//             const response = await UserService.getAllUsers();
//             if (response?.status && Array.isArray(response.data)) {
//                 const activeUsers = response.data.filter(
//                     (user) => user.status === "Active"
//                 );

//                 setUsers(activeUsers);

//                 const grouped = activeUsers.reduce((acc, user) => {
//                     const deptId = user.department_id || "no-dept";
//                     const deptName = user.department_name || "No Department";

//                     if (!acc[deptId]) {
//                         acc[deptId] = { name: deptName, users: [] };
//                     }
//                     acc[deptId].users.push(user);
//                     return acc;
//                 }, {});

//                 setGroupedUsers(grouped);
//             }
//         } catch (error) {
//             console.error("Error fetching users:", error);
//         }
//     };

//     useEffect(() => {
//         getAllUser();
//     }, []);

//     return (
//         <>
//             {msgContx}
//             <Form layout="vertical" form={form} onFinish={handleSubmit}>
//                 <Form.Item
//                     label="Title"
//                     name="title"
//                     rules={[{ required: true, message: "Please enter a title" }]}
//                 >
//                     <Input
//                         size="large"
//                         maxLength={30}
//                         showCount
//                         placeholder="Enter announcement title"
//                     />
//                 </Form.Item>

//                 <Form.Item label="Mention" name="mention">
//                     <Select
//                         showSearch
//                         allowClear
//                         mode="multiple"
//                         placeholder="Select users"
//                         size="large"
//                         style={{ minWidth: "50%", maxWidth: "100%" }}
//                         optionFilterProp="children"
//                         filterOption={(input, option) => {
//                             const { name, user_id, phone, department } = option?.user || {};
//                             const searchText = input.toLowerCase();
//                             return (
//                                 name?.toLowerCase().includes(searchText) ||
//                                 user_id?.toLowerCase().includes(searchText) ||
//                                 phone?.toLowerCase().includes(searchText) ||
//                                 department?.toLowerCase().includes(searchText)
//                             );
//                         }}
//                     >
//                         {Object.entries(groupedUsers).map(([deptId, deptData]) => (
//                             <OptGroup key={deptId} label={`Department: ${deptData.name}`}>
//                                 {deptData.users.map((item) => (
//                                     <Option
//                                         key={item.user_id}
//                                         value={item.user_id}
//                                         user={{
//                                             name: item.name,
//                                             user_id: item.user_id,
//                                             phone: item.phone,
//                                             department: item.department_name,
//                                         }}
//                                     >
//                                         {item.name} ({item.user_id}) — Ph:{item.phone}
//                                     </Option>
//                                 ))}
//                             </OptGroup>
//                         ))}
//                     </Select>
//                 </Form.Item>

//                 <Form.Item
//                     label="Content"
//                     name="content"
//                     rules={[{ required: true, message: "Please enter content" }]}
//                 >
//                     <TextArea rows={4} placeholder="Write announcement content here..." />
//                 </Form.Item>

//                 <Form.Item label="Upload Images" name="images">
//                     <Upload
//                         multiple
//                         listType="picture"
//                         beforeUpload={() => false} // prevent auto upload
//                         fileList={fileList}
//                         onChange={({ fileList }) => setFileList(fileList)}
//                     >
//                         <Button icon={<UploadOutlined />}>Upload</Button>
//                     </Upload>
//                 </Form.Item>

//                 <Form.Item>
//                     <Button type="primary" htmlType="submit" block>
//                         Post Announcement
//                     </Button>
//                 </Form.Item>
//             </Form>
//         </>
//     );
// };

// export default CreateAnnounce;
import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Select, message } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { UserService } from "../../Services/Manage/UserService";
import { AnnounceServices } from "../../Services/Room/AnnounceServices";

const { TextArea } = Input;
const { Option, OptGroup } = Select;

const CreateAnnounce = ({ onClose, editData = null }) => {
    const [form] = Form.useForm();
    const [users, setUsers] = useState([]);
    const [groupedUsers, setGroupedUsers] = useState({});
    const [fileList, setFileList] = useState([]);
    const [existingImage, setExistingImage] = useState(editData?.image || null);
    const [loading, setLoading] = useState(false);

    const isEditMode = !!editData;

    useEffect(() => {
        // Set form values when in edit mode
        if (isEditMode && editData) {
            form.setFieldsValue({
                title: editData.title,
                content: editData.description,
                mention: editData.mention ? JSON.parse(editData.mention) : []
            });
            setExistingImage(editData.image || null);
        }
        getAllUser();
    }, [editData, isEditMode, form]);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const formData = new FormData();
            const user = await UserService.getOmeUser();

            formData.append("title", values.title);
            formData.append("description", values.content);
            formData.append("added_by", user.uid);
            formData.append("mention", JSON.stringify(values.mention || []));

            if (isEditMode) {
                console.log("haiii...");
            }

            // Add new files
            fileList.forEach((file) => {
                if (file.originFileObj) {
                    formData.append("image", file.originFileObj);
                }
            });

            let res;
            if (isEditMode) {
                res = await AnnounceServices.updateAnnounce(editData.id, formData);
            } else {
                res = await AnnounceServices.createAnnounce(formData);
            }
            console.log(res);
            
            if (res.data.status) {
                message.success(
                    isEditMode 
                    ? "Announcement updated successfully!" 
                    : "Announcement posted successfully!"
                );
                form.resetFields();
                setFileList([]);
                setExistingImage(null);
                onClose(true); // Pass true to indicate success
            } else {
                message.error(res.data.message || `Failed to ${isEditMode ? 'update' : 'post'} announcement`);
            }
        } catch (err) {
            console.error(`Error ${isEditMode ? 'updating' : 'posting'} announcement:`, err);
            message.error(`Error ${isEditMode ? 'updating' : 'posting'} announcement`);
        } finally {
            setLoading(false);
        }
    };

    const getAllUser = async () => {
        try {
            const response = await UserService.getAllUsers();
            if (response?.status && Array.isArray(response.data)) {
                const activeUsers = response.data.filter(
                    (user) => user.status === "Active"
                );

                setUsers(activeUsers);

                const grouped = activeUsers.reduce((acc, user) => {
                    const deptId = user.department_id || "no-dept";
                    const deptName = user.department_name || "No Department";

                    if (!acc[deptId]) {
                        acc[deptId] = { name: deptName, users: [] };
                    }
                    acc[deptId].users.push(user);
                    return acc;
                }, {});

                setGroupedUsers(grouped);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const handleRemoveImage = () => {
        setExistingImage(null);
        // You might want to send a request to remove the image from server
        // This would require additional API endpoint
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);
    };

    return (
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please enter a title" }]}
            >
                <Input
                    size="large"
                    maxLength={30}
                    showCount
                    placeholder="Enter announcement title"
                />
            </Form.Item>

            <Form.Item label="Mention" name="mention">
                <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    placeholder="Select users"
                    size="large"
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const { name, user_id, phone, department } = option?.user || {};
                        const searchText = input.toLowerCase();
                        return (
                            name?.toLowerCase().includes(searchText) ||
                            user_id?.toLowerCase().includes(searchText) ||
                            phone?.toLowerCase().includes(searchText) ||
                            department?.toLowerCase().includes(searchText)
                        );
                    }}
                >
                    {Object.entries(groupedUsers).map(([deptId, deptData]) => (
                        <OptGroup key={deptId} label={`Department: ${deptData.name}`}>
                            {deptData.users.map((item) => (
                                <Option
                                    key={item.user_id}
                                    value={item.user_id}
                                    user={{
                                        name: item.name,
                                        user_id: item.user_id,
                                        phone: item.phone,
                                        department: item.department_name,
                                    }}
                                >
                                    {item.name} ({item.user_id}) — Ph:{item.phone}
                                </Option>
                            ))}
                        </OptGroup>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                label="Content"
                name="content"
                rules={[{ required: true, message: "Please enter content" }]}
            >
                <TextArea 
                    rows={4} 
                    placeholder="Write announcement content here..." 
                    maxLength={500}
                    showCount
                />
            </Form.Item>

            {/* Existing Image Display - Only in edit mode */}
            {isEditMode && existingImage && (
                <Form.Item label="Current Image">
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        <img
                            src={`${existingImage}`}
                            alt="Current announcement"
                            style={{ 
                                width: '200px', 
                                height: '120px', 
                                objectFit: 'cover', 
                                borderRadius: '8px',
                                border: '1px solid #d9d9d9'
                            }}
                        />
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            size="small"
                            style={{ 
                                position: 'absolute', 
                                top: '5px', 
                                right: '5px',
                                minWidth: '24px',
                                width: '24px',
                                height: '24px'
                            }}
                            onClick={handleRemoveImage}
                        />
                    </div>
                </Form.Item>
            )}

            <Form.Item 
                label={isEditMode ? "Upload New Images" : "Upload Images"}
                name="images"
                valuePropName="fileList"
                getValueFromEvent={normFile}
            >
                <Upload
                    multiple
                    listType="picture"
                    beforeUpload={() => false} // prevent auto upload
                    fileList={fileList}
                    onChange={handleUploadChange}
                    accept="image/*"
                >
                    <Button icon={<UploadOutlined />}>
                        {isEditMode ? "Add New Images" : "Upload Images"}
                    </Button>
                </Upload>
            </Form.Item>

            <Form.Item>
                <Button 
                    type="primary" 
                    htmlType="submit" 
                    block 
                    loading={loading}
                    size="large"
                >
                    {isEditMode ? "Update Announcement" : "Post Announcement"}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default CreateAnnounce;